/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const CalendarX = [
  "svg",
  defaultAttributes,
  [
    ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", ry: "2" }],
    ["line", { x1: "16", x2: "16", y1: "2", y2: "6" }],
    ["line", { x1: "8", x2: "8", y1: "2", y2: "6" }],
    ["line", { x1: "3", x2: "21", y1: "10", y2: "10" }],
    ["line", { x1: "10", x2: "14", y1: "14", y2: "18" }],
    ["line", { x1: "14", x2: "10", y1: "14", y2: "18" }]
  ]
];

export { CalendarX as default };
//# sourceMappingURL=calendar-x.js.map
